import {Injectable}      from '@angular/core'
import {BehaviorSubject} from 'rxjs/BehaviorSubject';
import {Factor} from "../model/factor";

@Injectable()
export class SliderService {
  // Observable item source
  private factor = new BehaviorSubject<Factor>(undefined);

  // Observable navItem stream
  factor$ = this.factor.asObservable();

  // service command
  editFactor(factor: Factor) {
    this.factor.next(factor);
  }
}
